"use client";

import * as React from "react";
import { SidebarAppLogo } from "./sidebar-app-logo";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarRail,
  useSidebar,
} from "@repo/web-ui/components/base/sidebar";
import NavPitchDesign from "./nav-pitch-design";
import NavResources from "./nav-resources";
import { ExternalLink, ShoppingCart, Store } from 'lucide-react'
import { useRouter } from "next/navigation";
import InstallPrompt from "../InstallPrompt";
import { useLocalStoreItem } from "../../utils/localStore";

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { state, setOpenMobile } = useSidebar()
  const router = useRouter()

  const handleNavigationClick = (href: string) => {
    router.push(href)
    setOpenMobile(false)
  }
  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader>
        <SidebarAppLogo />
      </SidebarHeader>
      <SidebarContent>
        <NavPitchDesign handleNavigationClick={handleNavigationClick} />
        <NavResources handleNavigationClick={handleNavigationClick} />
      </SidebarContent>
      <SidebarFooter>
        <SidebarMenu>
          <SidebarMenuItem>
            <a href='https://raviksports.com' target="_blank">
            <SidebarMenuButton size={'lg'} className="justify-center" tooltip={'RavikSports.com'}>
              {state === 'collapsed' && (
                <Store />
              )}
              {state !== 'collapsed' && (
                <>
                <span>RavikSports.com</span>
                <ExternalLink />
                </>
              )}
            </SidebarMenuButton>
            </a>
          </SidebarMenuItem>
          <InstallPrompt variant='sidebarMenuButton' state={state} />
          <SidebarMenuItem>
            {/* TODO(Update link to amazon page) */}
            <a href='https://www.amazon.com/stores/RavikSports/page/AC350CB5-FE57-4AB4-981C-44BC4C0934BB?is_byline_deeplink=true&deeplink=AC350CB5-FE57-4AB4-981C-44BC4C0934BB&redirect_store_id=AC350CB5-FE57-4AB4-981C-44BC4C0934BB&lp_asin=B0FN9KBDPG&ref_=cm_sw_r_ud_ast_store_1SBA212YFSS4E41A39CK' target="_blank">
            <SidebarMenuButton
              size={"lg"}
              className="bg-primary text-primary-foreground justify-center text-center"
              tooltip={'Buy Spin Command Balls'}
            >
              {state === 'collapsed' && (
                <ShoppingCart />
              )}
              {state !== 'collapsed' && (
                <span>Get Spin Command Balls</span>
              )}
            </SidebarMenuButton>
            </a>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
